import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';

/**
 * Step 1 (Flow Élève): Prénom de l'élève
 */
export default function Step1StudentName({
  formData,
  currentStepNumber,
  currentStepMessage,
  totalSteps,
  canContinue,
  validationMessage,
  onUpdateStudentInfo,
  onContinue,
  onBack,
}) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        totalSteps={totalSteps}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto flex flex-col items-center justify-center">
        {/* Icône */}
        <div className="w-20 h-20 rounded-full bg-[#38BDF8] flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Salut ! <span className="inline-block animate-wave">👋🏾</span>
        </h1>
        <p className="text-gray-500 mb-8">Bienvenue sur GeniMi</p>

        {/* Input prénom */}
        <div className="w-full max-w-sm bg-white rounded-2xl p-6 shadow-lg">
          <p className="font-semibold text-gray-800 text-center mb-4">
            Quel est ton prénom ?
          </p>
          <input
            type="text"
            value={formData.studentName || ''}
            onChange={(e) => onUpdateStudentInfo('studentName', e.target.value)}
            placeholder="Ex: Amadou, Aïcha, Moussa..."
            className="w-full p-4 border-2 border-gray-200 rounded-xl text-gray-700 text-center
                       focus:border-[#2DD4BF] focus:outline-none transition-colors text-lg"
            autoFocus
          />
        </div>

        {/* Astuce */}
        <div className="mt-6 bg-[#FEF3C7] rounded-xl p-4 max-w-sm w-full">
          <p className="text-gray-700 text-sm text-center flex items-center justify-center gap-2">
            <span>⭐</span>
            GeniMi va t'aider à progresser en lecture et maths !
          </p>
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        {validationMessage && !canContinue && (
          <p className="text-center text-sm text-gray-500 mb-2">{validationMessage}</p>
        )}
        <ContinueButton
          onClick={onContinue}
          disabled={!canContinue}
        />
      </div>
    </div>
  );
}
